import { WebinarCampaignsPage } from '@online-webinar/management';
import { RouterType } from '@online-webinar/router';
import { authGuard } from '../integrations/auth-guard';

export const updateRoute = (router: RouterType) => {
    router.routesById['/$webinarId/marketing/'].update({
        staticData: { title: { page: 'Marketing.PageHeading', forWebinar: true } },
        component: authGuard(WebinarCampaignsPage, { isWhitelabel: true, canManageEmailLists: true, canBroadcast: true })
    });
};
